import { useSelector } from "react-redux"
import { InputNumber, Number, RadioButtons } from ".."

const CurrencyPercentageInput = ({
  field,
  onChange,
  totalPrice,
  minAmount = 0,
  minPercentage = 0,
  maxAmount,
  maxPercentage,
  subtext,
  placeholder,
  disabled,
}) => {
  const currency = useSelector(
    state =>
      state?.app?.user?.info?.Agent?.AgencySettings?.find(currency => currency.key === "primary_currency").currencyCode
  )

  const handleValueChange = value => {
    if (!value) {
      return value
    }

    return field?.inputType === "%" ? ((totalPrice * value) / 100).toFixed(2) : value.toFixed(2)
  }

  const handlePercentageChange = value => {
    if (!value) {
      return value
    }
    return field?.inputType === currency ? ((value / totalPrice) * 100).toFixed(6) : value.toFixed(6)
  }

  const isPercentageInput = field?.inputType === "%"
  const displayValue = isPercentageInput
    ? isNaN(field?.percentage)
      ? ""
      : field?.percentage
    : isNaN(field?.value)
    ? ""
    : field?.value

  return (
    <>
      <InputNumber
        placeholder={placeholder}
        value={displayValue}
        controls={false}
        min={field?.inputType === "%" ? minPercentage.toFixed(6) : minAmount}
        max={field?.inputType === "%" ? maxPercentage.toFixed(6) : maxAmount}
        style={{ width: "100%" }}
        onChange={val => {
          onChange({
            value: handleValueChange(val),
            percentage:
              parseFloat(handlePercentageChange(val)) > parseFloat(maxPercentage.toFixed(6))
                ? maxPercentage.toFixed(6)
                : handlePercentageChange(val),
            inputType: field?.inputType,
          })
        }}
        disabled={disabled}
        addonAfter={
          <RadioButtons
            disabled={disabled}
            options={[
              { key: 1, label: "%", value: "%" },
              { key: 2, label: currency, value: currency },
            ]}
            value={field?.inputType}
            onChange={option => {
              const { value, percentage } = field
              onChange({ value, percentage, inputType: option.target.value })
            }}
            className="flexNowrap"
            btnSize="small"
          />
        }
      />
      {subtext && (
        <div style={{ "--typography-color": "#9D9D9D" }}>
          {field?.inputType === "%" ? (
            <Number isCurrency value={field?.value} />
          ) : (
            <Number value={field?.percentage} digitAfterFraction={6} wrapValue={v => `${v} %`} />
          )}
        </div>
      )}
    </>
  )
}

export default CurrencyPercentageInput
